import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GET_COURSES, GET_PROFESIONAL_RULES_LITE, GET_PROFESSIONAL_HAS_CONTACT_CENTER, USER_CHATS_LITE } from './graphql/queries';
import { map } from 'rxjs/operators';

@Injectable()
export class InovaNavGraphqlApi {
  constructor(private apollo: Apollo) { }

 
  getLiteUserChats(states: number[], limit: any = null){
    return this.apollo.use('it').query<any>({query: USER_CHATS_LITE, variables: {states, limit}}).pipe(
      map(result => {
        this.transformMessageResponse(result.data.chats);
        return result.data.chats;
      })
    );
  }

  getProfessionalHasContactCenter() {
    return this.apollo.use('it').query<any>({ query: GET_PROFESSIONAL_HAS_CONTACT_CENTER }).pipe(
      map(result => {
        return result.data.professionalHasContactCenter;
      })
    );
  }

  getCourses() {
    return this.apollo.use('it').query<any>({ query: GET_COURSES }).pipe(
      map(x => {
        return x.data.courses?.edges?.map((y:any) => y.node);
      }));
  }

  getProfessionalRulesLite() {
    return this.apollo.query<any>({ query: GET_PROFESIONAL_RULES_LITE }).pipe(
      map(result => {
        const data = result.data.profesionales.edges[0].node;
        return data.normas;
      })
    );
  }

  private transformMessageResponse(data: any[]){
    data.forEach(x => {
      x.estadoId = parseInt(x.estado.id);
      x.tipoId = parseInt(x.tipo.id);
      if (x.mensajechatSet && x.mensajechatSet.length > 0){
        x.messages = x.mensajechatSet;
        x.messages.forEach( (y:any) => {
          try {
            y.mensaje = JSON.parse(y.mensaje);
          } catch (error) {
            y.mensaje = {};
          }
        });
      }
    });
  }


}
